export default [
  {
    path: '/aiManage/skillManage',
    name: 'aiManage_skillManage',
    meta: {
      title: '能力管理',
      pageId: 'skillManage',
      pageName: '能力管理',
      parentId: 'aiManage',
      parentName: 'AI管理',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/aiManage/skillManage/skillManage'], resolve),
  },
  {
    path: '/aiManage/modelManage',
    name: 'aiManage_modelManage',
    meta: {
      title: '模型管理',
      pageId: 'modelManage',
      pageName: '模型管理',
      parentId: 'aiManage',
      parentName: 'AI管理',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/aiManage/modelManage/modelManage'], resolve),
  },
  {
    path: '/aiManage/tenantQuota',
    name: 'aiManage_tenantQuota',
    meta: {
      title: '租户配额',
      pageId: 'tenantQuota',
      pageName: '租户配额',
      parentId: 'aiManage',
      parentName: 'AI管理',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/aiManage/tenantQuota/tenantQuota'], resolve),
  },
  {
    path: '/aiManage/reportAuditManage',
    name: 'aiManage_reportAuditManage',
    meta: {
      title: '审核管理',
      pageId: 'reportAuditManage',
      pageName: '审核管理',
      parentId: 'aiManage',
      parentName: 'AI管理',
      pageLayer: 2,
    },
    component: resolve => require(['@/views/aiManage/reportAuditManage/reportAuditManage'], resolve),
  },
];
